import api from "./api";

const categoryService = {
  // Get all categories with filtering and pagination
  getAllCategories: async (params = {}) => {
    const response = await api.get("/api/categories", { params });
    return response.data.data || response.data;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveCategories: async () => {
    const response = await api.get("/api/categories/active");
    return response.data.data || response.data;
  },

  // Get category by ID
  getCategoryById: async (id) => {
    const response = await api.get(`/api/categories/${id}`);
    return response.data.data || response.data;
  },

  // Create new category with file upload
  createCategory: async (categoryData, imageFile = null) => {
    const formData = new FormData();

    // Add category data
    formData.append("name", categoryData.name);
    formData.append("description", categoryData.description || "");
    formData.append("status", categoryData.status || "active");

    // Add image file if provided
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.post("/api/categories", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Update category with file upload
  updateCategory: async (id, categoryData, imageFile = null) => {
    const formData = new FormData();

    // Add category data
    formData.append("name", categoryData.name);
    formData.append("description", categoryData.description || "");
    formData.append("status", categoryData.status || "active");

    // Add image_url if provided (for preserving existing image or handling removal)
    if (categoryData.image_url !== undefined) {
      formData.append("image_url", categoryData.image_url || "");
    }

    // Add image file if provided
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.put(`/api/categories/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Delete category
  deleteCategory: async (id) => {
    const response = await api.delete(`/api/categories/${id}`);
    return response.data.data || response.data;
  },

  // Update category status
  updateCategoryStatus: async (id, status) => {
    const response = await api.patch(`/api/categories/${id}/status`, {
      status,
    });
    return response.data.data || response.data;
  },

  // Get category statistics
  getCategoryStats: async () => {
    const response = await api.get("/api/categories/stats");
    return response.data.data || response.data;
  },
};

export default categoryService;
